import { InjectionToken, Provider } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';

export const EVERYDAY_SPEND_UNLEASH_KEY = 'rd_everyday_spend_woolworth';
export const EVERYDAY_SPEND_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('EVERYDAY_SPEND_ENABLED', {
    factory: () => false,
  });

export const provideEverydaySpendEnabled = (): Provider => ({
  provide: EVERYDAY_SPEND_ENABLED,
  useFactory: (unleashService: UnleashService) =>
    unleashService.isEnabled(EVERYDAY_SPEND_UNLEASH_KEY),
  deps: [UnleashService],
});
